// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"e6c1b50f","453":"45bd2994","879":"8f3d7223"}[chunkId] + ".chunk.js";
};